import { send } from '../../lib/send';

interface BackendEmailValidationResult {
  Input: { Email: string; Local: string; Host: string };
  IsValid: boolean;
  IsRisky: boolean;
  Suggestion: { Host: string };
}

export function validateEmail(
  baseURL: string,
  email: string
): Promise<BackendEmailValidationResult> {
  return send({
    baseURL,
    path: `/email-validation/validate?email=${encodeURIComponent(email)}`,
    method: 'GET',
  });
}
